import writeXlsxFile from "write-excel-file"
import { windowLock, windowRelease } from "./loader"
import { getMessage } from "../msgs/msgs"

export const formXlsxFromFlatArray = async (
  fileName: string,
  data: any[],
  isLockWindow = true,
) => {
  try {
    if (isLockWindow) {
      windowLock()
    }
    const schema: any[] = []
    Object.keys(data?.[0] || {}).forEach((key) => {
      schema.push({
        column: getMessage(key),
        value: (el: any) => el[key],
      })
    })
    writeXlsxFile(data, {
      fileName: `${fileName}.xlsx`,
      schema,
    })
  } finally {
    if (isLockWindow) {
      windowRelease()
    }
  }
}
